/* Http Client */
import request from '@/utils/http/request'


export const _STATUS = {
    1: "啟用",
    2: "停用",
}

export const _ADTYPE = {
    1: "Banner廣告",
    // 2: "彈窗廣告",
    // 3: "側邊欄廣告",
    // 4: "啟動頁廣告",
}
export const _POSITION = {
    1: "首頁",
    // 2: "分類頁",
    // 3: "個人中心",
    // 4: "活動頁",
    10: "PC首頁橫版",
    11: "PC探索橫版",
    12: "PC立即預約",
    13: "PC優惠推薦",
    14: "PC關於我們",
    15: "PC聯絡我們",
}

//List
export async function fetchAll({ status,displayPosition,adType,adName, pageSize, pageNumber }) {
    return await request.get('/advertisement', {
        params: {
            status,displayPosition,adType,adName, pageSize, pageNumber
        }

    });
}

//運動類型詳情
export async function fetch(id) {
    return await request.get(`/advertisement/${id}`);
}

//運動類型添加
export async function store({ adName, status, redirectUrl, adType, imageUrl, sortOrder, displayPosition, positionDesc }) {
    return await request.post('/advertisement', {
        adName, status, redirectUrl, adType, imageUrl, sortOrder, displayPosition, positionDesc
    });
}


export async function update({ id,adName,status,redirectUrl,adType,imageUrl,sortOrder,displayPosition,positionDesc }) {
    return await request.put(`/advertisement/${id}`, {
        id,adName,status,redirectUrl,adType,imageUrl,sortOrder,displayPosition,positionDesc
    });
}
//運動類型刪除
export async function destroy(id) {
    return await request.delete(`/advertisement/${id}`);
}


